import * as approvalFacadeImpl from "./approvalFacadeImpl";
import * as associatedFiles from "./associatedFiles";
import * as expenseReimbursement from "./expenseReimbursement";
import * as expenseReimbursementDetail from "./expenseReimbursementDetail";
import * as expenseReimbursementFacadeImpl from "./expenseReimbursementFacadeImpl";
import * as paymentBank from "./paymentBank";
import * as paymentBankInfoFacadeImpl from "./paymentBankInfoFacadeImpl";

export const rms = {
  approvalFacadeImpl,
  associatedFiles,
  expenseReimbursement,
  expenseReimbursementDetail,
  expenseReimbursementFacadeImpl,
  paymentBank,
  paymentBankInfoFacadeImpl,
};
